import React from "react";
import Footer from "../Footer/Footer";
import SaveCart from "../SaveCart/SaveCart";

const ShopInfo = () => {
  return (
    <div>
      <SaveCart/>
      <Footer />
    </div>
  );
};

export default ShopInfo;
